<template>
  <div>
    <v-card class="mx-3 mb-3">
      <v-card-title>
        Challenges
        <v-spacer/>
      </v-card-title>
      <v-card-text>
        <div v-if="loading">
          <v-progress-linear indeterminate></v-progress-linear>
        </div>
        <div v-else>
          <challenge name="Feuer und Flamme" icon="mdi-fire" iconColor="orange" iconSize="64" type="streak"
                     id="@InputStreak"
                     :levels="[  5,  10,  20,  35,  50,  75, 100, 150, 200, 365]"
                     description="Erreiche eine Eingabesträhne von @"/>
          <challenge name="Diamantenjäger" icon="mdi-diamond-stone" iconColor="blue" iconSize="50" type="gaming"
                     id="@gamification" subid="diamonds"
                     :levels="[  5, 10, 20, 50, 100, 200, 500, 1000, 2000, 5000]" description="Sammle @ Diamanten"/>

          <challenge name="Mein Leben" icon="mdi-medal-outline" iconColor="dunkelblau" iconSize="50"
                     type="gaming" id="@gamification" subid="badgeStreak_index_bronze"
                     :levels="[  5, 10, 20, 50, 100, 200, 300, 400, 500, 600]"
                     description="Erreiche @ Wochen in Serie eine Medaille beim Wochen-Index"/>

          <challenge name="Glückssträhne" icon="mdi-emoticon-happy-outline" iconColor="blue" iconSize="50"
                     type="gaming" id="@gamification" subid="badgeStreak_index_gold"
                     :levels="[  5, 10, 20, 50, 100, 200, 300, 400, 500, 600]"
                     description="Sei @ Wochen in Serie happy"/>

          <challenge name="Goldschürfer" icon="mdi-medal-outline" iconColor="gelb" iconSize="50" type="gaming"
                     id="@gamification" subid="totalBadges_gold"
                     :levels="[  5, 10, 20, 50, 100, 200, 300, 400, 500, 600]" description="Sammle @ Goldmedaillen"/>

          <challenge name="Medaillensammler" icon="mdi-medal-outline" iconColor="dunkelblau" iconSize="50" noDivider="true"
                     type="gaming" id="@gamification" subid="totalBadges"
                     :levels="[  5, 10, 20, 50, 100, 200, 300, 400, 500, 600]" description="Sammle @ Medaillen aller Art in allen Lebensbereichen" no-divider="true"/>
        </div>
      </v-card-text>
    </v-card>
    <v-card class="mx-3 mb-3"  v-for="b in bereiche">
      <v-card-title>
        {{b.name}}
        <v-spacer/>
      </v-card-title>
      <v-card-text>
        <div v-if="loading">
          <v-progress-linear indeterminate></v-progress-linear>
        </div>
        <div v-else>

<!--          bereichs-challenges-->
            <challenge name="Eingabesträhne" icon="mdi-fire" :iconColor="b.color" iconSize="64"
                       type="streak" :id="`@BereichStreak_${b.bid}`"
                       :levels="[  5,  10,  20,  35,  50,  75, 100, 150, 200, 365]"
                       description="Erreiche eine Eingabesträhne von @"/>
            <challenge name="Medaillensträhne" icon="mdi-medal-outline" :iconColor="b.color" iconSize="50"
                       type="gaming" id="@gamification" :subid="`badgeStreak_${b.bid}_bronze`"
                       :levels="[  5, 10, 20, 50, 100, 200, 300, 400, 500, 600]"
                       description="Erreiche @ Wochen in Serie eine Medaille"  :no-divider="activities.filter(x=>x.bereich===b.bid).length === 0" />

            <challenge v-for="(a, i) in activities.filter(x=>x.bereich===b.bid)" :name="a.name" icon="mdi-run-fast" :iconColor="b.color" iconSize="50"
                       type="streak" :id="`@ActivityStreak_${a.id}`"
                       :levels="[  5, 10, 20, 50, 100, 200, 300, 400, 500, 600]"
                       description="Erreiche eine Strähne von @" :no-divider="activities.filter(x=>x.bereich===b.bid).length === i+1"/>
        </div>
      </v-card-text>
    </v-card>
    <div class="d-flex">
      <v-btn class="mx-auto mt-3 mb-3" href="https://youtu.be/0G03P1gqFkk" target="_blank">
        <v-icon class="mr-2">mdi-play-box-outline</v-icon> Videoanleitung
      </v-btn>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import CenterContainer from "@/components/CenterContainer";
import UserLib from "@/components/UserLib";
import Header1 from "@/components/Header1";
import Kinds from "@/components/Kinds";
import Challenge from "@/components/Challenge";
import BEREICHE from "@/components/Bereiche";


const {DateTime} = require("luxon");

export default {
  name: 'Challenges',
  components: {CenterContainer, Header1, Challenge},
  data: () => ({
    loading: false,
    medals: [],
    activities: [],
  }),
  mounted() {
    this.load();
  },
  methods: {
    async load() {
      this.loading = true;
      //var id = Badge.makeId(this.weekDate.toISODate(), "index");
      // var badges = (await this.$backend.get_all_objects(Kinds.KIND_BADGE)) || [];
      // console.log("Badges: ", badges);
      // this.medals = badges;
      this.loading = false;
      var activities = (await this.$backend.get_all_objects(Kinds.KIND_ACTIVITY)) || [];
      this.activities = activities.filter(a=>a.challenge===true);
    },
    onHelpWochengesamtwertung() {
      this.$events.$emit("ask", {
        title: 'Challenges', yes_button: 'OK',
        question: 'todo',
      });
    },
  },
  computed: {
    app() {
      return this.$app;
    },
    numMedals() {
      return this.medals.length;
    },
    indexMedals() {
      return this.medals.filter(x => x.type === 'index');
    },
    bereiche() {
      var array = [];
      this.$app.bereiche.filter(x => !x.ignore).forEach(bereich => {
        var b = {
          bid: bereich.bid,
          type: bereich.type,
          name: bereich.name,
          color: BEREICHE.COLORS_BY_NAME[bereich.bid],
        };
        array.push(b);
      });
      return array;
    },
    numWeeks() {
      return this.indicesOfEpoch().length;
    }
  },
  watch: {
    // is_logged_in(n, o) {
    //     console.log("is_logged_in: " + n);
    //     if (!n) {
    //         this.$router.go(-1000);
    //         this.$router.replace("/")
    //     }
    // }
  }
}
</script>

<style>
.rb {
  border: red 1px solid;
}

.full_width {
  width: 100%;
}
</style>